import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SectionHead from "@/components/SectionHead";
import EmployerForm from "@/components/forms/EmployerForm";
import CandidateForm from "@/components/forms/CandidateForm";
import { EASE } from "@/components/Reveal";

const TABS = [
  {
    id: "employers",
    label: "For Employers",
    overline: "For Employers",
    title: "Looking for the Right Talent?",
    sub: "Tell us what you're looking for. Our recruitment specialists will help you identify relevant talent and streamline your hiring process.",
  },
  {
    id: "candidates",
    label: "For Candidates",
    overline: "For Job Seekers",
    title: "Your Next Opportunity Starts Here.",
    sub: "Explore career opportunities with leading organisations across India. Submit your profile and let our recruitment team connect you with relevant opportunities.",
  },
];

export default function EngageSection() {
  const [tab, setTab] = useState("employers");
  const active = TABS.find((t) => t.id === tab);

  return (
    <section data-testid="engage-section" className="relative bg-[#060B18] py-24">
      <div className="mx-auto max-w-4xl px-6">
        <div className="mb-10 flex justify-center">
          <div className="inline-flex rounded-full border border-white/[0.08] bg-[#0A0F1D] p-1.5">
            {TABS.map((t) => (
              <button
                key={t.id}
                data-testid={`engage-tab-${t.id}`}
                onClick={() => setTab(t.id)}
                className={`relative rounded-full px-6 py-2.5 text-sm font-semibold transition-colors duration-300 ${
                  tab === t.id ? "text-white" : "text-slate-400 hover:text-slate-200"
                }`}
              >
                {tab === t.id && (
                  <motion.span
                    layoutId="engage-tab-pill"
                    className="absolute inset-0 rounded-full bg-blue-600"
                    transition={{ duration: 0.4, ease: EASE }}
                  />
                )}
                <span className="relative z-10">{t.label}</span>
              </button>
            ))}
          </div>
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            key={tab}
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.45, ease: EASE }}
          >
            <SectionHead center overline={active.overline} title={active.title} sub={active.sub} testid={`engage-heading-${tab}`} />
            <div className="glass-card rounded-3xl p-7 sm:p-10">
              {tab === "employers" ? <EmployerForm /> : <CandidateForm />}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}
